import React from "react";
import "../styles/Process.css";
import { useLanguage } from "../contexts/LanguageContext";

const Process = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const p = text.process;

  return (
    <section id="process" className="process-section" dir={isHeb ? "rtl" : "ltr"}>
      <span className="eyebrow">{p.eyebrow}</span>
      <h2 className="section-title">{p.title}</h2>
      <p className="process-lede">{p.lede}</p>

      <ol className="process-grid">
        {p.steps.map((step, i) => (
          <li key={step.n} className="process-step" style={{ "--i": i }}>
            <div className="process-num">{step.n}</div>
            <h3 className="process-step-title">{step.title}</h3>
            <p className="process-step-desc">{step.desc}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default Process;
